module.exports = __webpack_public_path__ + "icon_alert_100red.6376c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_alert_100red.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_alert_100red.svg
// module chunks = main